import { mapActions } from "vuex";
import { getLocationOrigin, getQueryParams, wxQqParamsMd5} from "@/utils";

export default {
  data() {
    return {
      hasFromUrl:false, //开始是否是跳转过来
      isShowContent:false, //开始加载时判断是否显示内容
      relayParams:null
    }
  },
  beforeRouteEnter(to, from, next) {
    // console.log('to:', to)
    // console.log('from:', from)
    next((vm) => {
      vm.isJump(to.name,to.query,vm);
      if (from.path.match(/\/index_share/) !== null) {
        // vm.shareUrl = location.href.replace("/news_detail", "/index_share");
        vm.shareUrl=getLocationOrigin()+'/#'+from.fullPath;
        vm.hasFromUrl=true;
      } else {
        vm.shareUrl = location.href;
        vm.hasFromUrl=false;
      }
      
    });
  },
  methods: {
    ...mapActions('app', ["setUikCount"]),
    queryURLParams(url) {
      let pattern = /(\w+)=(\w+)/ig; //定义正则表达式
      let parames = {}; // 定义参数对象
      url.replace(pattern, ($, $1, $2) => {
        parames[$1] = $2;
      });
      return parames;
    },
    isJump(name,query,vm){ //根据缓存code判断是否改变code再次跳转当前页
      let newQuery=wxQqParamsMd5(query);
      let storageCount=sessionStorage.getItem('uikCount');
      if(newQuery && newQuery.uik){
        if(!storageCount){
          
          let pathParams= JSON.stringify(this.queryURLParams(window.location.href));
          if(pathParams!=''){
            sessionStorage.setItem('pathParams',pathParams);
          }
          console.log('pathParams:',pathParams);
          this.$emit('getMessage',0);
          this.isShowContent=false;
          sessionStorage.setItem('uikCount','1');
          console.log('newQuery==',newQuery)
          this.$router.replace({ name: name, query: newQuery })
          
          // this.$router.push({ name: name, query: newQuery });
          this.setUikCount(0)
        }
        else{
          
          this.isShowContent=true;
          sessionStorage.removeItem('uikCount');
          let pathParams=JSON.parse(sessionStorage.getItem('pathParams'));
          if(pathParams){
            this.relayParams=getQueryParams(pathParams);
            sessionStorage.removeItem('pathParams');
          }
          this.$emit('getMessage',1);
          this.setUikCount(1)
        }
      }
      else{
        this.isShowContent=true;
        this.$emit('getMessage',1);
      }
    },
  },

}